import { render, staticRenderFns } from "./ShoppingListV2.vue?vue&type=template&id=a89dd5de&scoped=true&"
import script from "./ShoppingListV2.vue?vue&type=script&lang=js&"
export * from "./ShoppingListV2.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingListV2.vue?vue&type=style&index=0&id=a89dd5de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89dd5de",
  null
  
)

export default component.exports